import colors from 'vuetify/lib/util/colors';
import base from '@/plugins/vuetify';
export const TColor = {
  data: () => ({
    light_mode: {
      delta_foreground_color: '',
      delta_light_mode: '',
    }
  }),

  computed: {
    theme_color() {
      if(this.$vuetify.theme.isDark) { return '#FFF'; }
      return '#000';
    },
  },

  methods: {
    // accepts hexadecimal colors and vuetify colors
    getColor(c) {
      // --- NO COLOR PROP SPECIFIED --- ///
      if(!c) {
        return this.theme_color;
      }

      if(this.isValidNonVuetifyColor(c)) {
        if(this.validateHexColor(c)) {
          return c;
        }

        let rgb_c = this.getHexColorFromRGB(c); // also rgba
        if(rgb_c) {
          return rgb_c;
        }

        let hsl_c = this.getHexColorFromHSL(c); // also hsla
        if(hsl_c) {
          return hsl_c;
        }
      }

      let vuetify_c = this.getHexColorFromVuetify(c);
      if(vuetify_c) {
        return vuetify_c;
      }

      let base_c = this.getHexColorFromVuetifyBase(c);
      if(base_c) {
        return base_c;
      }

      return this.theme_color; // if color doesn't exist in vuetify, default to theme color
    },

    validateHexColor(c) {
      // --- HEXCOLOR --- //
      // first character must be an hashtag
      if(c[0] != '#') {
        return false;
      }

      // checks if color is a valid hexadecimal color value
      var legal_chars = /[0-9A-Fa-f]/g;
      // #FFF, #FFF8 (Opacity), #FFFFFF, #FFFFFF88 (Opacity)
      if(!(c.length == 4 || c.length == 5 || c.length == 7 || c.length == 9) || !legal_chars.test(c)) {
        return false; // if any check fails, it can't be an hexadecimal value
      }
      return true;
    },

    getHexColorFromRGB(c) {
      // --- RGB COLOR ---//
      // first characters must be rgb (can also be rgba)
      if(c.substring(0, 3) != 'rgb') {
        return false;
      }

      // remove brackets and split by comma
      let values = c.split('(')[1].split(')')[0].split(',');
      // array must either have a length of 3 (rgb) or 4(rgba)
      if(!(values.length == 3 || values.length == 4)) {
        return false;
      }

      // assemble hexadecimal value
      let ret = '#';
      for(let i = 0; i < 3; i++) {
        // always use two digits for each value, each channel's value is between 0 and 255
        ret += ('0' + parseInt(values[i]).toString(16).toUpperCase()).slice(-2);
      }
      if(values.length == 4) {
        // alpha value is between 0 and 1.0
        ret += ('0' + parseInt(255 * values[3]).toString(16).toUpperCase()).slice(-2);
      }
      return ret;
    },

    getHexColorFromHSL(c) {
      // --- HSL COLOR ---//
      // first characters must be rgb (can also be rgba)
      if(c.substring(0, 3) != 'hsl') {
        return false;
      }

      // remove brackets and split by comma
      let values = c.split('(')[1].split(')')[0].split(',');
      // array must either have a length of 3 (hsl) or 4(hsla)
      if(!(values.length == 3 || values.length == 4)) {
        return false;
      }

      // https://stackoverflow.com/questions/36721830/convert-hsl-to-rgb-and-hex
      let h = values[0] / 360; // hue
      let s = values[1] / 100; // saturation
      let l = values[2] / 100; // lightness
      let r, g, b; // red, green, blue

      if (s === 0) {
        r = g = b = l; // achromatic
      } else {
        const hue2rgb = (p, q, t) => {
          if (t < 0) t += 1;
          if (t > 1) t -= 1;
          if (t < 1 / 6) return p + (q - p) * 6 * t;
          if (t < 1 / 2) return q;
          if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
          return p;
        };
        const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        const p = 2 * l - q;
        r = hue2rgb(p, q, h + 1 / 3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1 / 3);
      }
      const toHex = x => {
        const hex = Math.round(x * 255).toString(16);
        return hex.length === 1 ? '0' + hex : hex;
      };

      let ret = '#';
      ret += toHex(r);
      ret += toHex(g);
      ret += toHex(b);
      if(values.length == 4) {
        // alpha value is between 0 and 1.0
        ret += ('0' + parseInt(255 * values[3]).toString(16).toUpperCase()).slice(-2);
      }
      return ret;
    },

    getHexColorFromVuetify(c) {
      // --- VUETIFY COLOR ---//
      // references colors.js of vuetify npm module
      if (c.includes('black')) { return '#000' }
      if (c.includes('white')) { return '#FFF' }

      c = c.split(' '); // vuetify color hue and variant are seperated by ' '
      let vuetifyColor = ['red', 'base']; // vuetify colors contain color hue and variant
      for(let i = 0; i < c.length; i++) { // iterates at most two times
        let word = c[i].split('-'); // some colors and all variants are split by '-'
        if(word.length > 1) { // a '-' was used, apply camel case, turn array to string
          word = word[0] + word[1].charAt(0).toUpperCase() + word[1].slice(1); // there are at most two words
        }
        else { // otherwise turn array to string as is
          word = word[0];
        }
        vuetifyColor[i] = word;
      }

      // make sure attributes exist
      if(colors[vuetifyColor[0]] && colors[vuetifyColor[0]][vuetifyColor[1]]) {
        return colors[vuetifyColor[0]][vuetifyColor[1]];
      }
      return false;
    },

    getHexColorFromVuetifyBase(c) {
      // --- BASE COLOR ---//
      // references vuetify.js of vuetify npm module (plugins folder in src)
      let theme = this.$vuetify.theme.isDark ? 'dark' : 'light';
      let ret = base.preset.theme.themes[theme][c];
      // if attribute c does not exist, return undefined
      return ret;
    },

    isValidNonVuetifyColor(c) {
      let validator = new RegExp(/(#([\da-f]{3}){1,2}|(rgb|hsl)a\((\d{1,3}%?,\s?){3}(1|0?\.\d+)\)|(rgb|hsl)\(\d{1,3}%?(,\s?\d{1,3}%?){2}\))/ig);
      return validator.test(c);
    },

    // ----------------------------------------------------------------------//
    // NOTE: the following methods were originally in WorkPackageWIPMixin.mixin.js
    // NOTE: remove all references to original source
    // ----------------------------------------------------------------------//

    // transparent colors: call this when you want 'hex_color' to be 'opacity' percent opaque
    // hex_color is color in format of '#FFF', '#FFFFFF' (no transparency), '#FFFF', '#FFFFFFFF' (existing transparency)
    getTranspHexColor(hex_color, opacity) {
      // existing transparency gets discarded
      if(hex_color.length == 5) { hex_color = hex_color.slice(0, 4); }
      if(hex_color.length == 9) { hex_color = hex_color.slice(0, 7); }

      // checks if hex_color is a valid hexadecimal color value
      var legal_chars = /[0-9A-Fa-f]/g;
      if(hex_color[0] != '#' || !(hex_color.length == 4 || hex_color.length == 7) || !legal_chars.test(hex_color)) {
        return this.theme_color; // if color isn't a valid hexadecimal color, default to theme color
      }

      let hex_opacity;
      if(opacity === undefined) { opacity = .5 }
      if(hex_color.length == 4) { // if format is '#FFF' we can only increment by 1/16th
        hex_opacity = parseInt(15 * opacity).toString(16).toUpperCase();
      }
      else { // if format is '#FFFFFF' we can increment by 1/256th
        hex_opacity = parseInt(255 * opacity).toString(16).toUpperCase();
        if(hex_opacity.length != 2) { hex_opacity = '0' + hex_opacity }
      }

      return`${hex_color}${hex_opacity}`;
    },

    // hsl as object of hex color: call this when you need hsl values of hex color for example to check for luminosity
    // hex_color is color in format of '#FFF', '#FFFFFF' (no transparency), '#FFFF', '#FFFFFFFF' (existing transparency)
    getHexToHsl(hex_color) {
      // existing transparency gets discarded
      if(hex_color.length == 5) { hex_color = hex_color.slice(0, 4); }
      if(hex_color.length == 9) { hex_color = hex_color.slice(0, 7); }

      // checks if hex_color is a valid hexadecimal color value
      var legal_chars = /[0-9A-Fa-f]/g;
      if(hex_color[0] != '#' || !(hex_color.length == 4 || hex_color.length == 7) || !legal_chars.test(hex_color)) {
        return { h: 0, s: 50, l: 50};
      }

      // https://css-tricks.com/converting-color-spaces-in-javascript/
      // Convert hex to RGB first
      let r = 0, g = 0, b = 0;
      if (hex_color.length == 4) {
        r = "0x" + hex_color[1] + hex_color[1];
        g = "0x" + hex_color[2] + hex_color[2];
        b = "0x" + hex_color[3] + hex_color[3];
      } else if (hex_color.length == 7) {
        r = "0x" + hex_color[1] + hex_color[2];
        g = "0x" + hex_color[3] + hex_color[4];
        b = "0x" + hex_color[5] + hex_color[6];
      }

      // Then to HSL
      r /= 255;
      g /= 255;
      b /= 255;
      let cmin = Math.min(r,g,b),
          cmax = Math.max(r,g,b),
          delta = cmax - cmin,
          h = 0,
          s = 0,
          l = 0;

      if (delta == 0)
        h = 0;
      else if (cmax == r)
        h = ((g - b) / delta) % 6;
      else if (cmax == g)
        h = (b - r) / delta + 2;
      else
        h = (r - g) / delta + 4;

      h = Math.round(h * 60);

      if (h < 0)
        h += 360;

      l = (cmax + cmin) / 2;
      s = delta == 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
      s = +(s * 100).toFixed(1);
      l = +(l * 100).toFixed(1);
      return { h: h, s: s, l: l};
    },

    // returns a boolean which evaluates if light mode (#FFF) (true) or dark mode (#000) (false) should be used
    // is used for vuetify components, that can only be consistently shown as either black or white e.g. text-fields etc.
    is_light_mode(foreground_color) {
      let lm = this.light_mode;
      if(lm.delta_light_mode === '' || lm.delta_foreground_color != foreground_color) { // we want to call getHexToHsl as little as possible
        lm.delta_foreground_color = foreground_color;
        lm.delta_light_mode = this.getHexToHsl(foreground_color).l < 50;
      }
      return lm.delta_light_mode;
    },
  },
}
